import { Injectable } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { GridService } from "./grid.service";
import { EditorContentService } from '../services/editorcontent.service';

import * as $ from 'jquery';
import html2canvas from 'html2canvas';

//##################################################################################
//
// This service is used to keep track of all information about the navigation tasks
// 
//##################################################################################

declare var swal: any;
declare var fruitList: any;
declare var directions: any;
declare var colorList: any;
declare var shapeList: any;
declare var houseList: any;
declare var movableBoxesList: any;

@Injectable()
export class TeacherToolService {
    constructor(
        private gridService: GridService,
        private la: LanguageService,
        private editorContentService: EditorContentService) { }

    private iconTurtleVariable = 'app/img/turtles/turtle0.png';

    private tilesTeacherTool = [];

    // Creates boxes in teacher tool
    createBox(top: number, left: number) {
        let element = { positionHorizontal: left, positionVertical: top, isAllowed: true, walls: {} };
        let box = document.createElement("div");
        box.classList.add("boxTeacherTool");
        box.style.left = (element.positionHorizontal * 100) + 'px';
        box.style.top = (element.positionVertical * 100) + 'px';
        let isGrey = false;

        box.onclick = function () {
            // Prevent if we have a special object on this field
            if (box.children.length > 0) return;
            // Toggle between grey and white fields
            isGrey = box.classList.toggle("greyBoxTeacherTool");
            element.isAllowed = !isGrey;
        }

        /* ------------------- Everything related to drag and drop implementation -------------------*/
        box.ondragover = function allowDrop(ev) {
            ev.preventDefault();
        }

        box.ondrop = function handleDrop(ev) {
            ev.preventDefault();
            let data = JSON.parse(ev.dataTransfer.getData("Text"));

            // If we drop an element on a field which was previously set to 'not allowed', make it 'allowed' 
            if (isGrey) {
                box.classList.remove("greyBoxTeacherTool");
                isGrey = false;
                element.isAllowed = true;
            }

            // Make field white again if we drop a special element
            box.style.backgroundColor = "";

            // If there is already an object in this box, let the old one disappear and instead append the new object
            $(box).empty();

            // Check if there is already a turtle set
            let findVisibleTurtles = this.findTurtles();
            // Remove the old turtle if another turtle was found
            if (data.key.substring(0, 6) == "turtle" && findVisibleTurtles.length > 0) {
                findVisibleTurtles.remove();
            }

            // Create new special object
            let specialObj = document.createElement("div");
            specialObj.classList.add("specialObject");

            // Check if we have to append text or an image
            if (data.type == "spObj") {
                specialObj.setAttribute("id", data.key);
                specialObj.style.backgroundColor = box.style.backgroundColor;
                specialObj.style.backgroundImage = "URL(" + "./app/img/specialObjects/" + data.key + ".png" + ")";
                specialObj.style.backgroundRepeat = "no-repeat";
            } else if (data.type == "input") {
                specialObj.innerText = data.key;
                specialObj.setAttribute("id", "character");
            }

            // Make this created object draggable as well such that the user can drag it to other fields
            // and also remove it by dragging it outside the defined grid
            specialObj.draggable = true;
            specialObj.ondragstart = function (event) {
                specialObj.style.opacity = "0.4"; //visual feedback for user
                event.dataTransfer.setData("Text", JSON.stringify(data));
            };

            // Remove the object from the old location
            specialObj.ondragend = function () {
                $(specialObj).remove();
            }

            // Append the special object to the box
            box.appendChild(specialObj);
        }.bind(this);

        box.ondragenter = function enterDropZone() {
            box.style.backgroundColor = "rgb(230, 230, 230)"; //visual feedback for user
        }

        box.ondragleave = function dragLeave() {
            box.style.backgroundColor = ""; //visual feedback for user
        }
        /* ------------------------ End of drag and drop implementation ------------------------ */

        // Draw the 'add boxes' which enable the user to add new boxes by clicking on them
        // If the box is surrounded by boxes already, draw the hoverable walls
        if (this.findBox(top, left - 1) == null) {
            this.createAddBox(top, left - 1);
        } else {
            this.createWall(element, element.positionVertical, element.positionHorizontal, "teacherWallVertical", "left");
        }
        if (this.findBox(top, left + 1) == null) {
            this.createAddBox(top, left + 1);
        } else {
            this.createWall(element, element.positionVertical, element.positionHorizontal + 1, "teacherWallVertical", "right");
        }
        if (this.findBox(top - 1, left) == null) {
            this.createAddBox(top - 1, left);
        } else {
            this.createWall(element, element.positionVertical, element.positionHorizontal, "teacherWallHorizontal", "top");
        }
        if (this.findBox(top + 1, left) == null) {
            this.createAddBox(top + 1, left);
        } else {
            this.createWall(element, element.positionVertical + 1, element.positionHorizontal, "teacherWallHorizontal", "bottom");
        }

        // Push this box to the tiles array
        this.tilesTeacherTool.push(element);

        // Append to DOM
        document.getElementById("wrapperClickableGridCreator").appendChild(box);
    }

    // Create button that the user can click on to add other boxes and enlarge the field
    createAddBox(top: number, left: number) {
        // Prevent overflow
        if ((top + 1) * 100 > document.getElementById("wrapperClickableGridCreator").offsetHeight
            || (left + 1) * 100 > document.getElementById("wrapperClickableGridCreator").offsetWidth
            || top * 100 < 0
            || left * 100 < 0) {
            return;
        }

        // Create addBox
        let addBox = document.createElement("div");
        addBox.classList.add("boxTeacherTool");
        addBox.classList.add("appendTeacherTool");
        addBox.style.left = (left * 100) + 'px';
        addBox.style.top = (top * 100) + 'px';
        $(addBox).text("+");
        let boxElement = this;
        $(addBox).click(function () {
            boxElement.createBox(top, left);
            $(this).hide();
        });

        // Append to DOM
        document.getElementById("wrapperClickableGridCreator").appendChild(addBox);
    }

    // Create wall, responds to click and hover
    createWall(element, top: number, left: number, orientation: string, position: string) {
        let wall = document.createElement("div");
        wall.classList.add(orientation);
        if (orientation == "teacherWallVertical") {
            wall.classList.add("wrapperTeacherWallVertical");
            wall.style.left = (left * 100 - 4) + 'px';
            wall.style.top = (top * 100) + 'px';
        } else {
            wall.classList.add("wrapperTeacherWallHorizontal");
            wall.style.left = (left * 100) + 'px';
            wall.style.top = (top * 100 - 4) + 'px';
        }

        wall.onclick = function (event) {
            let el;
            event.stopPropagation();
            // Toggle between wall and no wall;
            // removes and returns false if the class wallPerm exists, if not, adds the class wallPerm and returns true
            let isWall = wall.classList.toggle("wallPerm");
            element.walls[position] = isWall;
            switch (position) {
                case "top": {
                    el = this.findBox(top - 1, left);
                    if (el != null) {
                        el.walls["bottom"] = isWall;
                    }
                    break;
                }
                case "bottom": {
                    el = this.findBox(top, left);
                    if (el != null) {
                        el.walls["top"] = isWall;
                    }
                    break;
                }
                case "left": {
                    el = this.findBox(top, left - 1);
                    if (el != null) {
                        el.walls["right"] = isWall;
                    }
                    break;
                }
                case "right": {
                    el = this.findBox(top, left);
                    if (el != null) {
                        el.walls["left"] = isWall;
                    }
                    break;
                }
            }
        }.bind(this);

        // Append to DOM
        document.getElementById("wrapperClickableGridCreator").appendChild(wall);
    }

    // Find box with the given position
    findBox(top, left) {
        return this.tilesTeacherTool.find(element => element.positionVertical == top && element.positionHorizontal == left);
    }

    // Find turtles which are children of 'boxTeacherTool' class members
    findTurtles() {
        return $(".boxTeacherTool").find("#turtle0, #turtle90, #turtle180, #turtle270");
    }

    checkIfTurtleSet() {
        let findTurtle = this.findTurtles();
        if (findTurtle.length == 0) {
            swal({
                title: 'Hoppla...',
                text: this.la.getLang()['noTurtle']
            });
            return false;
        }
        return true;
    }

    checkMovableBoxesRules(task) {
        // A task is not allowed to have more target boxes than movable boxes
        let counter = 0;
        task.specialObjects.forEach(element => {
            if (element.id == "movablebox") counter--;
            else if (element.id == "destinationbox") counter++;
        });
        if (counter > 0) {
            swal({
                title: 'Hoppla...',
                text: this.la.getLang()['moreTargetsThanBoxes']
            });
            return false;
        }
        return true;
    }

    performChecks() {
        let task = this.createTaskObject();
        return (this.checkIfTurtleSet() && this.checkMovableBoxesRules(task)) ? true : false;
    }

    // Draws the elements in the accordion
    drawDragAndDropElements() {
        // Close modal when clicking outside of its content       
        $('body').click(function (event) {
            if ($(event.target).is("#createExerciseModal.modal")) {
                $("#createExerciseModal").hide();
            }
        });

        // Accordion implementation according to https://www.w3schools.com/howto/howto_js_accordion.asp
        let acc = document.getElementsByClassName("accordion");
        // Add onclick listener to every accordion element
        for (let i = 0; i < acc.length; i++) {

            // Do not add event listener again after re-opening the modal
            if (document.getElementsByClassName("active").length > 0) break;

            acc[i].addEventListener("click", function () {
                // For toggling purposes detect if the clicked section is already "active"
                let isActive = this.classList.contains("active");

                // Close all accordions
                let allAccordions = document.getElementsByClassName("accordion");
                for (let j = 0; j < allAccordions.length; j++) {
                    // Remove active class from section header
                    allAccordions[j].classList.remove("active");

                    // Remove the max-height class from the panel to close it
                    let panel = <HTMLElement>allAccordions[j].nextElementSibling;
                    let maxHeightValue = getStyle(panel, "maxHeight");

                    if (maxHeightValue !== "0px") {
                        panel.style.maxHeight = null;
                    }
                }

                // Toggle the clicked section using a ternary operator
                isActive ? this.classList.remove("active") : this.classList.add("active");

                // Toggle the panel element
                let panel = <HTMLElement>this.nextElementSibling;
                let maxHeightValue = getStyle(panel, "maxHeight");

                if (maxHeightValue !== "0px") {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

        // Cross-browser way to get the computed height of a certain element. Credit to @CMS on StackOverflow (http://stackoverflow.com/a/2531934/7926565)
        function getStyle(el, styleProp) {
            let value, defaultView = (el.ownerDocument || document).defaultView;
            // W3C standard way:
            if (defaultView && defaultView.getComputedStyle) {
                // sanitize property name to css notation
                // (hypen separated words eg. font-Size)
                styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
                return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
            } else if (el.currentStyle) { // IE
                // sanitize property name to camelCase
                styleProp = styleProp.replace(/\-(\w)/g, function (str, letter) {
                    return letter.toUpperCase();
                });
                value = el.currentStyle[styleProp];
                // convert other units to pixels on IE
                if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
                    return (function (value) {
                        var oldLeft = el.style.left, oldRsLeft = el.runtimeStyle.left;
                        el.runtimeStyle.left = el.currentStyle.left;
                        el.style.left = value || 0;
                        value = el.style.pixelLeft + "px";
                        el.style.left = oldLeft;
                        el.runtimeStyle.left = oldRsLeft;
                        return value;
                    })(value);
                }
                return value;
            }
        }

        // Draw all special objects according to their category
        if (directions.length != $("#turtleWrapper").children().length) {
            $("#turtleWrapper").empty();
            directions.forEach(function (dir) {
                this.createDragAndDropElement("turtle" + dir, "turtleWrapper");
            }.bind(this));
        }

        if (fruitList.length != $("#fruitWrapper").children().length) {
            $("#fruitWrapper").empty();
            fruitList.forEach(function (element) {
                this.createDragAndDropElement(element, "fruitWrapper");
            }.bind(this));
        }

        if (colorList.length != $("#colorWrapper").children().length) {
            $("#colorWrapper").empty();
            colorList.forEach(function (element) {
                this.createDragAndDropElement(element, "colorWrapper");
            }.bind(this));
        }

        if (shapeList.length != $("#shapeWrapper").children().length) {
            $("#shapeWrapper").empty();
            shapeList.forEach(function (element) {
                this.createDragAndDropElement(element, "shapeWrapper");
            }.bind(this));
        }

        if ($("#lettersAndNumbersWrapper").children().length != 1) {
            $("#lettersAndNumbersWrapper").empty();
            let dragAndDropElement = document.createElement("div");
            dragAndDropElement.setAttribute("id", "dragAndDropInputElement");
            dragAndDropElement.classList.add("dragAndDropElement");
            dragAndDropElement.style.backgroundColor = "white";
            dragAndDropElement.style.boxShadow = "0 0 30px #333";
            dragAndDropElement.draggable = true;
            document.getElementById("lettersAndNumbersWrapper").appendChild(dragAndDropElement);
        }

        if (houseList.length != $("#houseWrapper").children().length) {
            $("#houseWrapper").empty();
            houseList.forEach(function (element) {
                this.createDragAndDropElement(element, "houseWrapper");
            }.bind(this));
        }

        if (movableBoxesList.length != $("#movableBoxesWrapper").children().length) {
            $("#movableBoxesWrapper").empty();
            movableBoxesList.forEach(function (element) {
                this.createDragAndDropElement(element, "movableBoxesWrapper");
            }.bind(this));
        }

        // Open the first accordion, but only if there is none active yet (important when re-opening the menu)
        if (document.getElementsByClassName("active").length == 0) {
            let firstAccordion = acc[0];
            let firstPanel = <HTMLElement>firstAccordion.nextElementSibling;
            firstAccordion.classList.add("active");
            firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
        }

        $(acc[4]).click(function (e) {
            $("[id=inputLettersAndNumbers]").focus(); //visual help for user
        });
    }

    // Get input for special objects "draggable letters and numbers"
    // and create the appropriate drag and drop element
    getInput() {
        let dragAndDropElement = document.getElementById("dragAndDropInputElement");
        dragAndDropElement.innerText =
            (<HTMLInputElement>document.getElementById("inputLettersAndNumbers")).value;

        dragAndDropElement.ondragstart = function (event) {
            dragAndDropElement.style.opacity = "0.4"; //visual Feedback for user
            let obj = { type: "input", key: dragAndDropElement.innerHTML };
            event.dataTransfer.setData("Text", JSON.stringify(obj));
        }.bind(this);
        dragAndDropElement.ondragend = function () {
            // set the opacity back to 100%
            dragAndDropElement.style.opacity = "1";
        }
    }

    // Create the drag and drop elements that are drawn into the accordion
    createDragAndDropElement(element, id: string) {
        let dragAndDropElement = document.createElement("div");
        dragAndDropElement.classList.add("dragAndDropElement");
        dragAndDropElement.setAttribute("id", element);
        dragAndDropElement.style.backgroundImage = "URL(./app/img/specialObjects/" + element + ".png)";
        dragAndDropElement.draggable = true;
        dragAndDropElement.ondragstart = function (event) {
            dragAndDropElement.style.opacity = "0.4"; //visual Feedback for user
            let obj = { type: "spObj", key: dragAndDropElement.id };
            event.dataTransfer.setData("Text", JSON.stringify(obj));
        }.bind(this);
        dragAndDropElement.ondragend = function () {
            // set the opacity back to 100%
            dragAndDropElement.style.opacity = "1";
        }
        document.getElementById(id).appendChild(dragAndDropElement);
    }

    // Read out the data for the newly created task and return the task object
    createTaskObject() {
        let task = { id: "", turtleData: {}, tiles: [], specialObjects: [] };
        // Get taskname from input field
        task.id = (<HTMLInputElement>document.getElementById("inputIdTeacherTool")).value;
        task.tiles = this.tilesTeacherTool;
        // read out position and ids from dragged and dropped special objects
        // and add this information to task object
        let findSpecialObj = $(".boxTeacherTool").find(".specialObject");
        if (findSpecialObj.length > 0) {
            findSpecialObj.each(function () {
                if ($(this).attr("id").substring(0, 6) == "turtle") {
                    let turtleData = {
                        positionVertical: Math.round($(this).parent().position().top / 100),
                        positionHorizontal: Math.round($(this).parent().position().left / 100),
                        direction: parseInt($(this).attr("id").substr(6), 10)
                    };
                    task.turtleData = turtleData;
                } else {
                    let specialObj = {
                        id: $(this).attr("id"),
                        positionVertical: Math.round($(this).parent().position().top / 100),
                        positionHorizontal: Math.round($(this).parent().position().left / 100),
                        value: $(this).attr("id") == "character" ? this.innerHTML : 1
                    };
                    task.specialObjects.push(specialObj);
                }
            });
        }
        return task;
    }

    // Open the created exercise
    exportExercise() {
        let task = this.createTaskObject();
        this.gridService.openExercise(task, this.iconTurtleVariable, true, null, null);
        this.gridService.setTitle(task.id);
    }

    // Read the text file and open the appropriate exercise
    openFile(event) {
        let input = event.target;
        let reader = new FileReader();
        reader.onload = function () {
            let task = JSON.parse(reader.result + "");
            this.gridService.openExercise(task, this.iconTurtleVariable, true);
            this.gridService.setTitle(task.id)
        }.bind(this);
        reader.readAsText(input.files[0]);
    }

    // Save the created task to server and receive 4-digit code
    saveTaskToServer() {
        let task = this.createTaskObject();
        $.ajax({
            url: "https://xlogo.inf.ethz.ch/foo/save",
            type: "POST",
            data: JSON.stringify(task),
            contentType: "application/json",
            dataType: 'json',
            success: function (data) {
                let key = data.key;
                swal({
                    type: 'success',
                    title: this.la.getLang()['key'] + ':',
                    text: key
                });
            }.bind(this)
        });
    }

    // Load task from server by entering the 4-digit code
    loadTaskFromServer(key: string) {
        $.ajaxSetup({
            "error": function () {
                swal({
                    type: 'error',
                    title: 'Error!',
                    text: key + " " + this.la.getLang()['doesNotExist']
                });
            }.bind(this)
        });
        $.getJSON("https://xlogo.inf.ethz.ch/foo/show/" + key, function (data) {
            this.gridService.openExercise(data, this.iconTurtleVariable, true);
            this.gridService.setTitle(data.id);
        }.bind(this))
    }

    // Download the task as text file
    downloadTask() {
        this.editorContentService.downloadFile("task_" + this.getCurrentDate() + ".txt", JSON.stringify(this.createTaskObject(), null, 1));
    }

    // Clear the teacher tool wrapper
    clear() {
        $("#wrapperClickableGridCreator").empty();
        $("#dragAndDropInputElement").empty();
        (<HTMLInputElement>document.getElementById("inputLettersAndNumbers")).value = "";
        (<HTMLInputElement>document.getElementById("inputIdTeacherTool")).value = "";
        this.tilesTeacherTool = [];
        this.createBox(1, 1);
    }

    // Save the canvas as png file
    saveCanvas() {
        html2canvas(document.getElementById("stack")).then(function (canvas) {
            let temp = <HTMLAnchorElement>document.getElementById('DOM-attached-download');
            temp.href = canvas.toDataURL('image/png');
            temp.download = $("#exerciseTitle").text() + "_" + this.getCurrentDate() + ".png";
            temp.click();
        }.bind(this));
    }

    // Retrun the current date dd/mm/yyyy
    getCurrentDate() {
        let dateObj = new Date();
        let month = dateObj.getUTCMonth() + 1;
        let day = dateObj.getUTCDate();
        let year = dateObj.getUTCFullYear();
        return day + '/' + month + '/' + year;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/teachertool.service.ts